// src/components/auth/AuthPrompt.tsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserCircleIcon, LockClosedIcon } from '@heroicons/react/24/outline';

interface AuthPromptProps {
  title?: string;
  message?: string;
  buttonText?: string;
  displayStyle?: 'card' | 'inline';
}

/**
 * A standardized authentication prompt component for use across the app
 */
const AuthPrompt: React.FC<AuthPromptProps> = ({
  title = 'Authentication Required',
  message = 'Please sign in with your Spotify account to access this feature.',
  buttonText = 'Sign in with Spotify',
  displayStyle = 'card'
}) => {
  const location = useLocation();
  
  return (
    <div className={`${displayStyle === 'card' ? 'bg-blue-50 border border-blue-200 rounded-lg shadow-sm' : ''} p-6 max-w-md mx-auto`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="rounded-full bg-blue-100 p-2">
            <LockClosedIcon className="h-5 w-5 text-blue-600" />
          </div>
        </div>
        
        <div className="ml-3">
          <h3 className="text-lg font-medium text-blue-800">{title}</h3>
          <div className="mt-2">
            <p className="text-sm text-blue-700">{message}</p>
          </div>
          
          <div className="mt-4">
            <Link
              to="/login"
              state={{ returnPath: location.pathname }}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <UserCircleIcon className="h-5 w-5 mr-2" />
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPrompt;